import React from 'react';

const WhatsAppWidget: React.FC = () => {
  const whatsappLink = 'https://api.whatsapp.com/send?phone=+593995886995&text=Hola.%20Estoy%20interesado/a%20en%20los%20servicios%20de%20Lexis';

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 whatsapp-widget group"
      aria-label="Contactar por WhatsApp"
    >
      {/* Pulse animation background */}
      <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75"></div>
      
      {/* Main button */}
      <div className="relative bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110">
        <img 
          src="/footer/icon_whatsapp.svg" 
          alt="WhatsApp" 
          className="h-8 w-8"
        />
      </div>

      {/* Tooltip */}
      <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-xl">
        ¿Necesitas ayuda? ¡Escríbenos!
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-45 w-2 h-2 bg-gray-900"></div>
      </div>
    </a>
  );
};

export default WhatsAppWidget;
